import { render, staticRenderFns } from "./DisplayId.vue?vue&type=template&id=1a106a3c&scoped=true"
import script from "./DisplayId.vue?vue&type=script&lang=js"
export * from "./DisplayId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a106a3c",
  null
  
)

export default component.exports